import api from '@/api';

export default {
	state: {
		summary: null,
		progress: null
	},
	mutations: {
		SET_SCHOOL_TEACHERS_SUMMARY (state, summary) {
			state.summary = summary;
		},
		SET_SCHOOL_TEACHERS_PROGRESS (state, progress) {
			state.progress = progress;
		},
		CLEAR_SCHOOL_TEACHERS_SUMMARY (state) {
			state.summary = null;
		},
		CLEAR_SCHOOL_TEACHERS_PROGRESS (state) {
			state.progress = null;
		}
	},
	actions: {
		async setSchoolTeachersSummary (context, summary) {
			context.commit('SET_SCHOOL_TEACHERS_SUMMARY', summary);
		},

		async setSchoolTeachersProgress (context, progress) {
			context.commit('SET_SCHOOL_TEACHERS_PROGRESS', progress);
		},

		async clearSchoolTeachersSummary (context) {
			context.commit('CLEAR_SCHOOL_TEACHERS_SUMMARY');
		},

		async clearSchoolTeachersProgress (context) {
			context.commit('CLEAR_SCHOOL_TEACHERS_PROGRESS');
		}
	}
};



// WEBPACK FOOTER //
// ./src/store/teachers/index.js